import React, { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import io from "socket.io-client";
import "./helper/FirebaseConfig";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import RouterLink from "./routes/RouterLink";
import { middleware } from './middleware/middleware';
import AnnouncementPopup from "./components/AnnouncementPopup/AnnouncementPopup";
import InstallPWA from "./components/InstallPWA/InstallPWA";
import { getUserDataFromLCStorage, getDeviceId } from "./helper";
import consts from "./consts";
import { SERVER_URL } from "./api";

function App() {
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const newSocket = io(SERVER_URL, {
      transports: ["polling", "websocket"],
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 2000,
      reconnectionDelayMax: 10000,
      timeout: 20000,
    });
    newSocket.on("connect_error", (err) => {
      console.warn("App socket connect_error (will auto-retry):", err.message);
    });
    setSocket(newSocket);
    ReactGA.initialize("G-DVRRYD683K");
    ReactGA.send("pageview");

    return () => {
      newSocket.disconnect();
    };
  }, []);

  // ===== Login One Device: ຖ້າ login ຈາກບ່ອນອື່ນ → ເຕະ session ເກົ່າອອກ =====
  useEffect(() => {
    if (socket) {
      const userId = getUserDataFromLCStorage()?._id;
      if (userId) {
        socket.on("LOGIN_CUSTOMER:" + userId, (data) => {
          // ຖ້າ IP ປ່ຽນ = login ຈາກບ່ອນອື່ນ → logout ທັນທີ
          if (data.ip !== getUserDataFromLCStorage()?.ipLogin) {
            localStorage.removeItem(consts.USER_DATA);
            localStorage.removeItem(consts.ACCESS_TOKEN_WEB);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        });
      }
    }
  }, [socket]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  middleware();
  getDeviceId(); // ===== ສ້າງ device_id ເກັບໄວ້ =====
  return (
    <div>
      <AnnouncementPopup />
      <InstallPWA />
      <RouterLink />
    </div>
  );
}

export default App;
